@if (!preferenceService.cargando) {
  <app-slider
    [preferences]="this.preferenceService.preferences"
    [selectedDepartmentId]="departmentId"
    >
  </app-slider>
}
@if (loading || preferenceService.cargando) {
  <mat-spinner class="spinner">
  </mat-spinner>
}
@if (!loading || preferenceService.cargando) {
  <app-special-products
    [products]="articles"
    [cantpages]="cantpages"
    [page]="page"
    [loading]="loading"
    (nextPage)="onNext()"
    (previous)="onPrev()"
  ></app-special-products>
}
